import { createRoute, lazyRouteComponent } from "@tanstack/react-router"
import { Route as RootRoute } from "../../__root"

/**
 * Roles & permissions list -- `/settings/roles`. Page body lazy-loaded.
 */
export const Route = createRoute({
	getParentRoute: () => RootRoute,
	path: "/settings/roles",
	component: lazyRouteComponent(() => import("./index.page")),
})
